module.exports = require('../../es/array/from');



//////////////////
// WEBPACK FOOTER
// C:/wamp64/www/lepetitsalon/wp-content/themes/digitalcover/node_modules/core-js/features/array/from.js
// module id = 57
// module chunks = 0